import React from 'react';
import { Modal } from 'antd';

const ImageDescriptionDetailModal = ({ open, onClose, imageSrc, descriptionData }) => {
  if (!descriptionData) return null;

  const isObject = typeof descriptionData === 'object';

  return (
    <Modal
      open={open}
      title="Дополнительное описание изображения"
      onCancel={onClose}
      footer={null}
      width="min(720px, calc(100vw - 24px))"
      centered
    >
      <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
        {imageSrc && (
          <div className="theme-preview-box" style={{ textAlign: 'center', padding: 12 }}>
            <img
              src={imageSrc}
              alt=""
              style={{ maxWidth: '100%', maxHeight: 180, objectFit: 'contain', borderRadius: 6 }}
            />
          </div>
        )}

        {isObject ? (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
            {descriptionData.semantic_description && (
              <div className="theme-desc-section">
                <div className="theme-desc-section__header">Семантическое описание</div>
                <div className="theme-desc-section__body">{descriptionData.semantic_description}</div>
              </div>
            )}

            {Array.isArray(descriptionData.elements) && descriptionData.elements.length > 0 && (
              <div className="theme-desc-section">
                <div className="theme-desc-section__header">Элементы</div>
                <div style={{ padding: 14, display: 'flex', flexWrap: 'wrap', gap: 8 }}>
                  {descriptionData.elements.map((el, i) => (
                    <span key={i} className="theme-desc-tag theme-desc-tag--info">
                      {el}
                    </span>
                  ))}
                </div>
              </div>
            )}

            {Array.isArray(descriptionData.colors) && descriptionData.colors.length > 0 && (
              <div className="theme-desc-section">
                <div className="theme-desc-section__header">Цвета</div>
                <div style={{ padding: 14, display: 'flex', flexWrap: 'wrap', gap: 8 }}>
                  {descriptionData.colors.map((c, i) => (
                    <span key={i} className="theme-desc-tag theme-desc-tag--success">
                      {c}
                    </span>
                  ))}
                </div>
              </div>
            )}

            {descriptionData.text_content && (
              <div className="theme-desc-section">
                <div className="theme-desc-section__header">Текстовое содержимое</div>
                <div className="theme-desc-section__body theme-warning-surface">
                  {descriptionData.text_content}
                </div>
              </div>
            )}
          </div>
        ) : (
          <div className="theme-desc-section__body theme-preview-box" style={{ padding: 14, borderRadius: 8 }}>
            {String(descriptionData)}
          </div>
        )}
      </div>
    </Modal>
  );
};

export default ImageDescriptionDetailModal;
